import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { ConfirmClickDirective } from './confirm-click.directive'
import { AppDropdownDirective } from './dropdown.directive'
import { DropdownAnchorDirective } from './dropdown-anchor.directive'
import { DropdownLinkDirective } from './dropdown-link.directive'
import { HasAccessDirective } from './has-access.directive'
import { HasIntegrationSupportDirective } from './has-integration-support.directive'
import { HasModuleDirective } from './has-module.directive'
import { HasPermissionDirective } from './has-permission.directive'
import { TrimValueAccessorDirective } from './trim-value-accessor'

@NgModule({
  imports: [CommonModule],
  declarations: [
    AppDropdownDirective,
    ConfirmClickDirective,
    DropdownAnchorDirective,
    DropdownLinkDirective,
    TrimValueAccessorDirective,
    HasAccessDirective,
    HasPermissionDirective,
    HasIntegrationSupportDirective,
    HasModuleDirective,
  ],
  exports: [
    AppDropdownDirective,
    ConfirmClickDirective,
    DropdownAnchorDirective,
    DropdownLinkDirective,
    TrimValueAccessorDirective,
    HasAccessDirective,
    HasPermissionDirective,
    HasIntegrationSupportDirective,
    HasModuleDirective,
  ],
})
export class DirectivesModule {}
